import React from 'react';
import { Building2 } from 'lucide-react';
import { useScopeEntities } from '../../../hooks/analytics/useScopeReports.ts';
import { StatCard, WidgetCard } from '../controller/shared.tsx';

/** `scope_entities` — count of legal entities / business units in scope. */
export const ScopeEntitiesCard: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useScopeEntities();

  return (
    <WidgetCard
      title="Entities in Scope"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load entities in scope.'}
      isEmpty={!isLoading && !isError && !data}
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <StatCard
        title="Entities In Scope"
        value={data?.total ?? 0}
        icon={<Building2 className="h-5 w-5" />}
        color="bg-indigo-100 text-indigo-600"
        subtitle={
          data && data.entities.length > 0
            ? `${data.entities.slice(0, 3).map((e) => e.name).join(', ')}${data.entities.length > 3 ? '…' : ''}`
            : undefined
        }
      />
    </WidgetCard>
  );
};

export default ScopeEntitiesCard;
